<template>
  <div id="vaccination-pane">
    <v-expansion-panels>
      <v-expansion-panel class="mb-2 panel" inset>
        <v-expansion-panel-header>
          <span class="h5 gray--text text-center">
            Do you want to be vaccinated?
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="mb-3">
            <label class="main blue lighten-4 cursor-pointer" @click="panelEligibility = panelEligibility === 0 ? null : 0">
              Nationwide eligibility criteria
            </label>
            <v-expansion-panels class="no-style" v-model="panelEligibility">
              <v-expansion-panel >
                <v-expansion-panel-content>
                  <div class="mb-2">Defined by CDC</div>
                  <ul>
                    <li>
                      Frontline health workers 
                    </li>
                    <li>Long-term care residents & staff</li>
                    <li>
                      First responders
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">information</v-icon>
                        </template>
                        <span>{{firstRespondersHint}}</span>
                      </v-tooltip></li>
                    <li>
                      Frontline essential workers
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">information</v-icon>
                        </template>
                        <span>{{frontlineEssentialWorkersHint}}</span>
                      </v-tooltip>
                    </li>
                    <li>
                      Essential workers
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">information</v-icon>
                        </template>
                        <span>{{essentailWorkersHint}}</span>
                      </v-tooltip>
                    </li>
                    <li>Persons over 75</li>
                    <li>Persons from 65 to 74</li>
                    <li>
                      High risk conditions
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">information</v-icon>
                        </template>
                        <span>{{highRiskHint}}</span>
                      </v-tooltip>
                    </li>
                    <li>
                      Living in congregate settings
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on">information</v-icon>
                        </template>
                        <span>{{congregateSettingsHint}}</span>
                      </v-tooltip>
                    </li>
                    <!-- <li>General population</li> -->
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <label class="main green lighten-4 my-3">
            State-level eligibility criteria
            <!-- Choose your state to find vaccination site and registry -->
          </label>
          <div class="mb-2">
            Here Million Patients Cured (MPC) has been updating information for your state.<br>
            Each state defines its categories based on vaccine supply. <br>
            Choose your state to see the priority categories for vaccination. <br>
            Find vaccination sites and signup for the waitlist.
          </div>
          <v-autocomplete placeholder="State" item-value="name" item-text="name" :items="states" v-model="selectedState" clearable outlined dense hide-details hint=""></v-autocomplete>
          <div v-if="selectedState">
            <label v-if="stateCriteria['Last Updated']">Criteria as of {{stateCriteria['Last Updated']}}</label>
            <ul>
              <li v-for="(field, ix) in fields" :key="ix">
                {{field}}: {{stateCriteria[field] || "-"}}
              </li>
            </ul>
            <v-row class="text-center">
              <v-col v-if="stateCriteria['Informational']"><v-btn :href="stateCriteria['Informational']" color="default">Click here to get more information</v-btn></v-col>
              <v-col v-if="stateCriteria['Registration / Vac Location']"><v-btn :href="stateCriteria['Registration / Vac Location']" color="default">Click here to register for the waitlist</v-btn></v-col>
            </v-row>
          </div>
          <div>


            <label class="main pink lighten-4 my-3">
              Your eligibility
            </label>
            <div class="text-center pt-1">
              <div class="text-left pb-3">
                Million Patients Cured will let you know when you meet the criteria.
                Register here for you or your familiy to be notified.
              </div>
              <v-btn color="primary" @click="notifyMeDialog=true">Get notified when you are eligible</v-btn>
              <br>
            </div>
          </div>
          <div>
            
            <label class="main yellow lighten-4 mb-2 my-3">
              Your travel options
            </label>
            <div class="text-left">
              
Soon countries, governments and schools will require vaccination records for entry.
<br>
We are tracking the requirements and can notify you based on their criteria.
<br>
<v-row>
  <v-col class="d-flex py-1 text-fields">
    <v-row>
      <v-col class="pa-0" :cols="12" :sm="2">
        <v-autocomplete label="State*" item-value="code" item-text="name" :items="states" v-model="vaccinatedForm.stateCode" class="mt-3 mr-2" outlined dense hide-details hint=""></v-autocomplete>

      </v-col>
      <v-col class="pa-0" :cols="12" :sm="2">
        <v-text-field label="Name*" class="mt-3 mr-2" v-model="vaccinatedForm.name" outlined dense hide-details></v-text-field>
        
      </v-col>
      <v-col class="pa-0" :cols="12" :sm="2">
        <v-text-field label="Email*" class="mt-3 mr-2" v-model="vaccinatedForm.email" outlined dense hide-details></v-text-field>
        
      </v-col>
      <v-col class="pa-0" :cols="12" :sm="6">
        
        <v-btn color="primary" class="register-vaccinated-btn mt-3" @click="registerVaccinated()" :disabled="!validVaccinatedForm()">
          Register and go to travel site
        </v-btn>
      </v-col>
    </v-row>
            
    <!-- <v-text-field label="Name*" class="mx-1 my-2" v-model="registerDetails.name" outlined dense hide-details hint=""></v-text-field>
    <v-text-field label="Email*" class="mx-1 my-2" v-model="registerDetails.email" outlined dense hide-details hint=""></v-text-field>
    <v-text-field label="Zip Code*" class="mx-1 my-2" v-model="registerDetails.zip" outlined dense hide-details hint=""></v-text-field>
    <v-autocomplete label="State" class="mx-1 my-2" v-model="registerDetails.state" :items="states" outlined dense hide-details hint=""></v-autocomplete>
    <v-autocomplete label="County" class="mx-1 my-2" v-model="registerDetails.county" :items="counties" outlined dense hide-details hint=""></v-autocomplete> -->
    <!-- <button id="registerUpdatesBtn" type="submit" @click="register">
      Register and go to the travel site
    </button> -->
  </v-col>
</v-row>
<!-- <div class="checks">
  <v-checkbox class="mt-1" v-model="registerDetails.freeTest" :hide-details="true" label="Email me info on free tests so I can help prevent the spread of disease"></v-checkbox>
  <v-checkbox class="mt-1" v-model="registerDetails.getPaid" :hide-details="true" label="Email me info about how to get paid for research to help save the world"></v-checkbox>
  <v-checkbox class="mt-1" v-model="registerDetails.receiveUpdates" :hide-details="true" label="Email me info on state mandates and county updates so that I can comply or travel"></v-checkbox>
</div> -->
<!-- <button id="registerUpdatesBtn" type="submit" @click="register">
  Register and go to the travel site
</button> -->
<!-- [3 inputs] -->
<!-- We are tracking when the requirements are published.
<br>
Register to be notified of where you can travel based on their criteria. -->
<!-- <br> -->
              <!-- <span>Register here if you have been vaccinated so we can notify where you can travel based on other countries' criteria.</span>
              <br>
              <span>Million Patients Cured has gathered travel requirements from counties around the world for you to search easily.</span>
              <br> -->
              
              <v-row class="text-center">
                <!-- <v-col>
                  <v-btn color="default" @click="showVaccinatedDialog = true">
                    Get notified where you can travel
                  </v-btn>
                </v-col> -->
                <v-col><v-btn color="default" to="/travel">Search for travel criteria</v-btn></v-col>
              </v-row>
            </div>

          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="notifyMeDialog" persistent>
      <v-card>

        <v-card-title class="headline">
          Registration
        </v-card-title>

        <v-card-text>
          <label>Please choose all the criteria that applies to you or your family:</label>
          <v-row>
            <v-col :cols="12" :sm="6">
              <v-checkbox label="Frontline health workers" v-model="notifyMeForm.frontLineHealthWorkers" hide-details class="mt-0" dense></v-checkbox>
              <v-checkbox label="Long-term care residents & staff" v-model="notifyMeForm.longTermCareResidents" hide-details class="mt-0" dense></v-checkbox>
              <v-checkbox label="First responders" v-model="notifyMeForm.firstResponders" hide-details class="mt-0" dense></v-checkbox>
              <v-checkbox label="Frontline essential workers " v-model="notifyMeForm.frontlineEssentialWorkers" hide-details class="mt-0" dense></v-checkbox>
              <v-checkbox label="Essential workers" v-model="notifyMeForm.essentialWorkers" hide-details class="mt-0" dense></v-checkbox>
              <v-checkbox label="Living in congregate settings" v-model="notifyMeForm.congregateSettings" hide-details class="mt-0" dense></v-checkbox>

              <v-text-field label="Zip Code*" :maxlength="5" class="mt-3" @change="zipCodeChanged" v-model="notifyMeForm.zipCode" outlined dense hide-details></v-text-field>
              <v-autocomplete label="State*" item-value="code" item-text="name" :items="states" v-model="notifyMeForm.stateCode" class="mt-3" outlined dense hide-details hint=""></v-autocomplete>
              <v-autocomplete label="Age group*" :items="ageGroups" v-model="notifyMeForm.ageGroup" class="mt-3" outlined dense hide-details hint=""></v-autocomplete>
              <v-text-field label="Email*" class="mt-3" v-model="notifyMeForm.email" outlined dense hide-details></v-text-field>

            </v-col>
            <v-col :cols="12" :sm="6">
              <v-checkbox label="High risk conditions for you or your family" v-model="notifyMeForm.highRiskConditions" hide-details class="mt-0" dense></v-checkbox>
              <ul class="pl-8">
                <li>Cancer</li>
                <li>Chronic kidney disease</li>
                <li>COPD</li>
                <li>Heart conditions such as heart failure, coronary artery disease or cardiomyopathies</li>
                <li>Immunocompromised state</li>
                <li>Sliid organ transplant</li>
                <li>Obesity BMI >30 kg/m2</li>
                <li>Sickle cell disease</li>
                <li>Smoking</li>
                <li>Type 2 diabetes</li>
                <li>Pregnancy</li>
              </ul>

            </v-col>
          </v-row>
          
        <v-divider></v-divider>
          <label>Type of vaccine</label>
          <v-checkbox label="Traditional vaccine" hide-details class="mt-0" dense v-model="notifyMeForm.traditionalVaccine"></v-checkbox>
          <v-checkbox label="Emergency use vaccine" hide-details class="mt-0" dense v-model="notifyMeForm.emergencyUseVaccine"></v-checkbox>
       
        </v-card-text>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="notifyMeDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="registerNotifyMe()" :disabled="!validNotifyMeForm()">
            Register
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showVaccinatedDialog" persistent>
      <v-card>

        <v-card-title class="headline">
          Registration
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col :cols="12" :sm="6">
              <v-autocomplete label="State*" item-value="code" item-text="name" :items="states" v-model="vaccinatedForm.stateCode" class="mt-3" outlined dense hide-details hint=""></v-autocomplete>
              <v-text-field label="Name*" class="mt-3" v-model="vaccinatedForm.name" outlined dense hide-details></v-text-field>
              <v-text-field label="Email*" class="mt-3" v-model="vaccinatedForm.email" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col :cols="12" :sm="6">
          
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="showVaccinatedDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="registerVaccinated()" :disabled="!validVaccinatedForm()">
            Register and go to travel site
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="2000" :color="snackbarColor">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as d3 from "d3"
import _ from "lodash"
import stateCodes from '../state-codes'
import zipCodes from '../zip-codes'

let toLowerTrimmed = (str) => {
  if (!str || !str.toLowerCase) {
    return str
  }

  return str.toLowerCase().trim()
}

export default {
  props: {
  },
  data: () => ({
    firstRespondersHint: "Firefighters and police officers",
    frontlineEssentialWorkersHint: "Corrections officers, Food and agriculture workers, U.S. Postal Service workers, manufacturing workers, grocery store workers, public transit workers, and those who work in the education sector (teachers, support staff members) as well as child care workers.",
    highRiskHint: "Cancer; chronic kidney disease; COPD; heart conditions such as heart failure, coronary artery disease or cardiomyopathies; immunocompromised state; solid organ transplant; obesity BMI >30 kg/m2; sickle cell disease; smoking; type 2 diabetes; pregnancy.",
    essentailWorkersHint: "Transportation and logistics, waste and wastewater, food service, shelter and housing, (e.g. construction), finance (e.g. bank tellers), information technology and communication, energy, legal, media, and public safety (e.g. engineers).",
    congregateSettingsHint: "Correctional or detention facilities, homeless shelters, group homes, or employer provided shared housing units.",

    fields: [
      "Frontline health workers",
      "Long-term care residents & staff",
      "First responders",
      "Frontline essential workers",
      "Essential workers",
      "Persons over 75",
      "Persons over 70",
      "Persons over 65",
      "Persons over 55",
      "High risk conditions",
      "Living in congregate settings",
      "General population",
    ],

    snackbarText: '',
    snackbar: false,
    snackbarColor: 'info',

    selectedState: null,
    states: stateCodes,
    ageGroups: [
      "16 to 54",
      "55 to 64",
      "65 to 69",
      "70 to 74",
      "75 or more" ,
    ],
    notifyMeDialog: false,
    showVaccinatedDialog: false,
    notifyMeForm: {
      experimental: true,
      traditional: true,
      stateCode: null,
    },
    vaccinatedForm: {},
    panelEligibility: 0,
    statesCriteria: null,
    stateCriteria: {},
  }),
  watch: {
    selectedState() {
      if (this.selectedState) {
        this.panelEligibility = null
        this.stateCriteria = this.statesCriteria.find(d => toLowerTrimmed(d["State"]) == toLowerTrimmed(this.selectedState)) || {}
      } else {
        this.panelEligibility = 0
        this.stateCriteria = {}
      }
    }
  },
  created() {
    d3.csv("us-vaccine-state-criteria.csv").then(res => (this.statesCriteria = res))

  },
  methods: {
    zipCodeChanged() {
      if (this.notifyMeForm && this.notifyMeForm.zipCode && this.notifyMeForm.zipCode.length == 5) {
        let prefix = this.notifyMeForm.zipCode.substring(0, 3)
        let stateCode = zipCodes[prefix]
        let state = stateCodes.find(sc => sc.code == stateCode)
        if (state) {
          this.notifyMeForm.stateCode = state.code
        }
      }
    },
    validNotifyMeForm() {
      return this.notifyMeForm 
        && this.notifyMeForm.zipCode 
        && this.notifyMeForm.stateCode
        && this.notifyMeForm.ageGroup
        && this.notifyMeForm.email
    },
    validVaccinatedForm() {
      return this.vaccinatedForm 
        && this.vaccinatedForm.stateCode
        && this.vaccinatedForm.name
        && this.vaccinatedForm.email
    },
    registerNotifyMe() {

      let details = this.notifyMeForm

      fetch(
        "https://testsites.millionpatientscured.com:5000/api/notifyMeVaccinationRecord",
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(details)
        }
      )
        .then(() => {
          console.log("success registering notifyMeForm")

          this.notifyMeForm = {
            experimental: true,
            traditional: true,
            stateCode: null,
          }

          this.notifyMeDialog = false

          this.snackbar = true
          this.snackbarText = "Thanks for registering!"
          this.snackbarColor = "info"
        })
        .catch(function(error) {
          console.log("error registering notifyMeForm")
          this.snackbar = true
          this.snackbarText = "Error registering"
          this.snackbarColor = "error"
          console.log(error)
        })
    },
    registerVaccinated() {

      let details = this.vaccinatedForm

      fetch(
        "https://testsites.millionpatientscured.com:5000/api/vaccinatedRecord",
        {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(details)
        }
      )
        .then(() => {
          console.log("success registering vaccinatedForm")

          this.vaccinatedForm = {}

          this.vaccinatedDialog = false

          this.snackbar = true
          this.snackbarText = "Thanks for registering!"
          this.snackbarColor = "info"
        })
        .catch(function(error) {
          console.log("error registering vaccinatedForm")
          this.snackbar = true
          this.snackbarText = "Error registering"
          this.snackbarColor = "error"
          console.log(error)
        })
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.cursor-pointer {
  cursor: pointer;
}

#vaccination-pane {
  position: relative;

  .main {
    display: block;
    background: #eeeefe;
    border-radius: 0;
    padding: 4px 24px;
    margin: 0 -24px 4px -24px;
  }

  .panel {
    border: 1px solid #d2d2d2;
    background: #ffffffbb;
  }

  .v-expansion-panels.no-style {
    .v-expansion-panel {
      background: transparent;
    }
    .v-expansion-panel::before {
      box-shadow: none;
    }
    .v-expansion-panel .v-expansion-panel-content__wrap {
      padding: 0;
    }
  }

  .register-vaccinated-btn {
    height: 40px;
  }
  
  @media only screen and (max-width: 600px) {

    font-size: 12px;

    .h5, h5 {
      font-size: 14px;
    }
    .v-expansion-panel-header {
      min-height: 20px;
      height: 20px;
      padding: 0;
    }
    
    .v-input {
      // width: 300px;
      input {
        min-width: 1px !important;
      }
      .v-input__slot, .v-input__control {
        min-height: 28px !important;
      }
      .v-select__slot label {
        top: 4px!important;
      }
      .v-input__append-inner {
        margin-top: 4px;
      }
    }

  }
}
</style>
